import { useState } from "react";
import { Button } from "@oc-labs/wt-storybook";
import { Download, Plus } from "lucide-react";
import TokensProvider from "./TokensProvider";
import SortableTokenTable from "./SortableTokenTable";
import useTokenSettings from "./useTokenSettings";
import ModalImportToken from "../../../components/modals/ModalImportToken";
import ModalDeployToken from "../../../components/modals/ModalDeployToken";
import ModalEditToken from "../../../components/modals/ModalEditToken";
import ModalConfirmDelete from "../../../components/modals/ModalConfirmDelete";
import useModal from "../../../hooks/useModal";

function TokensContent() {
  const { networks, selectedNetwork, setSelectedNetwork, abis, importToken, createToken, editToken, deleteToken, generateContract } = useTokenSettings();
  const importModal = useModal("importToken");
  const deployModal = useModal("deployToken");
  const editModal = useModal("editToken");
  const [deleteTarget, setDeleteTarget] = useState(null);

  const handleEdit = (contract) => {
    editModal.open({ token: contract });
  };

  const handleDelete = (contract) => {
    setDeleteTarget(contract);
  };

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    await deleteToken(deleteTarget.id);
    setDeleteTarget(null);
  };

  return (
    <div>
      <div className="flex justify-between items-center">
        <div className="flex flex-wrap gap-2">
          {networks?.map((network) => (
            <div className="inline-block" key={network.id}>
              <Button
                type={selectedNetwork?.id === network.id ? "primary" : "tertiary"}
                size="small"
                onClick={() => setSelectedNetwork(network)}
              >
                {network.name}
              </Button>
            </div>
          ))}
        </div>
        <div className="flex gap-2">
          <Button type="tertiary" size="small" onClick={() => importModal.open()}>
            <Download className="w-4 h-4 mr-1 inline-block" />
            Import Token
          </Button>
          <Button type="primary" size="small" onClick={() => deployModal.open()} className="whitespace-nowrap">
            <Plus className="w-4 h-4 mr-1 inline-block" />
            Create Token
          </Button>
        </div>
      </div>

      <SortableTokenTable onEdit={handleEdit} onDelete={handleDelete} />

      <ModalImportToken
        networks={networks}
        abis={abis}
        defaultNetworkId={selectedNetwork?.id}
        onImport={importToken}
      />
      <ModalDeployToken
        networks={networks}
        defaultNetworkId={selectedNetwork?.id}
        onDeploy={createToken}
        onGenerate={generateContract}
      />
      <ModalEditToken networks={networks} abis={abis} onEdit={editToken} />
      <ModalConfirmDelete
        isOpen={!!deleteTarget}
        closeModal={() => setDeleteTarget(null)}
        onConfirm={confirmDelete}
        title="Delete Token"
        description={`Are you sure you want to delete "${deleteTarget?.name}"? This action cannot be undone.`}
      />
    </div>
  );
}

export default function Tokens() {
  return (
    <TokensProvider>
      <TokensContent />
    </TokensProvider>
  );
}
